import { useGetNavigateSearchParams } from 'hooks';

const URL_PARAM_NAME = 'token';

export const useUrlToken = () => {
  const { token } = useGetNavigateSearchParams([URL_PARAM_NAME]);

  return token;
};
